// Vendor Components
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';
import classnames from 'classnames';

// Components
import Dropdown from '../components-core/dropdown';

// Redux Actions
import {resetForm} from '../actions/form-data-actions';
import {layoutReset} from '../actions/layout-actions';
import {resetServiceData} from '../actions/services-data-actions';

class LoggedInDropdown extends Component {
    getDropdownProps() {
        const {className} = this.props;

        return {
            className: classnames('logged-in-dropdown', className),
            dropdownRenderer: this.renderDropdownItems,
            type: 'link',
        };
    }

    renderDropdownItems = () => (
        <ul>
            <li>
                <Link to="/change-password">Change Password</Link>
            </li>
            <li>
                <Link to="/logout">Logout</Link>
            </li>
        </ul>
    );

    render() {
        const {username} = this.props;

        return username ? <Dropdown {...this.getDropdownProps()}>Logged in as {username}</Dropdown> : null;
    }
}

LoggedInDropdown.propTypes = {
    className: PropTypes.string,
    layoutReset: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    resetServiceData: PropTypes.func.isRequired,
    username: PropTypes.string,
};

function mapStateToProps(state) {
    return {
        username: state.auth.user,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({layoutReset, resetForm, resetServiceData}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedInDropdown);
